/* eslint-disable no-return-await */
import {Repository} from './Repository'

export default {
  async getPlans (planType) {
    // eslint-disable-next-line no-return-await
    return await Repository.get(`/plans_list/` + planType)
  },
  async checkout (data) {
    return await Repository.post('/api/make_payment', data)
  },
  async planByID (planid) {
    return await Repository.get('/api/currentPlan')
  },
  async cancelSubscription () {
    return await Repository.get('/api/cancelSubscription')
  },
  async payByPayPal (data) {
    return await Repository.post('/api/payByPayPal', data)
  },
  async PayPalSuccess (data) {
    return await Repository.get(`/api/processPayPal?${data}`)
  },
  async getExchangeRate (data) {
    return await Repository.get(`https://xecdapi.xe.com/v1/convert_to.json/?to=USD&from=${data}&amount=1`, {
      auth: {
        username: 'priceriversinc395390877',
        password: 'geftoipadrk4hj98nac0272lh2'
      }
    })
  },
  async getSavedCards () {
    return await Repository.get(`/api/getSavedCards`)
  },
  async saveCard (data) {
    return await Repository.post(`/api/saveNewCard`, data)
  },
  async deleteCard (data) {
    return await Repository.post(`/api/deleteCard`, data)
  },
  async getFreePlan () {
    return Repository.get('/api/getFreePlan')
  }
}



// WEBPACK FOOTER //
// ./src/repositories/paymentsRepository.js